export default "__VITE_ASSET__DGHpzWK$__"